import React from 'react';
import Project from './Components/Project';

const ProjectIndex: React.FC = () => {
  return <Project />;
};
export default ProjectIndex;
